import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/documentation/documentation/node_modules/gatsby-theme-doctornpm/src/components/layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Note = makeShortcode("Note");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`To help others find your packages on npm and have a good experience using your code in their projects, we recommend including a README file in your package directory. Your README file may include directions for installing, configuring, and using the code in your package, as well as any other information a user may find helpful. The README file will be shown on the package page.`}</p>
    <p>{`An npm package README file must be in the root-level directory of the package.`}</p>
    <h2>{`Creating and adding a README.md file to a package`}</h2>
    <ol>
      <li parentName="ol">{`In a text editor, in your package root directory, create a file called `}<inlineCode parentName="li">{`README.md`}</inlineCode>{`.`}</li>
      <li parentName="ol">{`In the `}<inlineCode parentName="li">{`README.md`}</inlineCode>{` file, add useful information about your package.`}</li>
      <li parentName="ol">{`Save the `}<inlineCode parentName="li">{`README.md`}</inlineCode>{` file.`}</li>
    </ol>
    <Note mdxType="Note">
      <p><strong parentName="p">{`Note:`}</strong>{` The file extension `}<inlineCode parentName="p">{`.md`}</inlineCode>{` indicates a Markdown file. For more information about Markdown, see the GitHub Guide "`}<a href="https://guides.github.com/features/mastering-markdown/#what">{`Mastering Markdown`}</a>{`".`}</p>
    </Note>
    <h2>{`Updating an existing package README file`}</h2>
    <p>{`The README file will only be updated on the package page when you publish a new version of your package. To update your README file:`}</p>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`In a text editor, update the contents of the `}<inlineCode parentName="p">{`README.md`}</inlineCode>{` file.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Save the `}<inlineCode parentName="p">{`README.md`}</inlineCode>{` file.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`On the command line, in the package root directory, run the following commands:`}</p>
        <pre parentName="li"><code parentName="pre" {...{}}>{`npm version patch
npm publish
`}</code></pre>
      </li>
    </ol>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      